import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter, Switch } from 'react-router-dom';

// style sheet
import './css/style.css';

// COMPONENTS
import Header from './Components/Header';
import Navigation from './Components/Navigation';
import Footer from './Components/Footer';

// VIEWS
import NoMatch from './Views/err/NoMatch';
import Home from './Views/Home';
import Orientations from './Views/Orientations';
import Ecosystem from './Views/Ecosystem';
import Perspectives from './Views/Perspectives';
// import Organigramme from './Views/Organigramme';

// COMPONENTS
import Carousel from './Views/Components/Carousel';
import SecondaryFooter from './Views/Components/SecondaryFooter';

ReactDOM.render(
  <BrowserRouter>
    <div className="container-fluid wrapper">
      <div className="container">
        <div id="bga"></div>
        <Header />
        <Navigation />
        <Switch>
          <Route exact path="/" component={ Home } />
          <Route exact path="/orientations" component={ Orientations } />
          <Route exact path="/ecosystem" component={ Ecosystem } />
          <Route exact path="/perspectives" component={ Perspectives } />
          {/* <Route exact path="/organigramme" component={ Organigramme } /> */}

          {/* error page */}
          <Route component={ NoMatch } status={ 404 } />
        </Switch>
      </div>
      <Carousel />
      <SecondaryFooter />
      <Footer />
    </div>
  </BrowserRouter>
, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js